// extracted by mini-css-extract-plugin
module.exports = {"container":"TypeForm_container__15jXJ","main":"TypeForm_main__1K8hn","media":"TypeForm_media__avPI1"};